import { css } from 'styled-components';

const scrollBarStyle__hidden = css `
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;
const scrollBarStyle = css `
    &::-webkit-scrollbar {
        width: 18px;
    }
    &::-webkit-scrollbar-thumb {
        box-shadow: inset 0px 0px 10px 10px #e6e6e6;
        border: 5px solid transparent;
        border-radius: 16px;
    }
`;

export { scrollBarStyle, scrollBarStyle__hidden };
//# sourceMappingURL=scrollbar.js.map
